/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Page_TitleInputs */

const en_faq_page_title = /** @type {(inputs: Faq_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQs`)
};

const fr_faq_page_title = /** @type {(inputs: Faq_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQs`)
};

/**
* | output |
* | --- |
* | "FAQs" |
*
* @param {Faq_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_page_title = /** @type {((inputs?: Faq_Page_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Page_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_page_title(inputs)
	return fr_faq_page_title(inputs)
});